import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import { BadgeComponent, DropdownItemComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'reports-visualization-actions-dropdown-item',
  imports: [DropdownItemComponent, IconComponent, BadgeComponent, TranslatePipe],
  template: `
    <rt-dropdown-item
      [class.upsell]="upsell()"
      [attr.data-cy]="'reports:report:action-' + action()"
    >
      <rt-icon prefix [name]="icon()" />
      <div layout layout-space-between layout-align-items-center>
        <div class="name-container">
          <span>
            {{ label() }}
          </span>

          @if (isNew()) {
            <rt-badge
              margin-left-small-x
              color="pink-gradient"
              [text]="'app.common.new' | translate"
            />
          }
        </div>

        @if (upsell()) {
          <rt-icon name="upgrade" size="small-x" />
        }
      </div>

      @let suffixIconValue = suffixIcon();
      @if (suffixIconValue) {
        <rt-icon suffix [name]="suffixIconValue" />
      }
    </rt-dropdown-item>
  `,
  styles: `
    .name-container {
      rt-badge,
      span {
        vertical-align: middle;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisualizationActionsDropdownItemComponent {
  public label = input<string>();
  public icon = input.required<IconName>();
  public action = input<string>();
  public suffixIcon = input<IconName>();
  public isNew = input<boolean>(false);
  public upsell = input<boolean>(false);
}
